// Local stub for the Inventory MastersService.
// HRMS does not ship the Inventory module, so these methods short-circuit to
// empty results instead of calling a non-existent inventory backend.
class MastersServiceStub {
  GetMenus(_type: any, _roleId: any, _organizationId: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
  CheckMenuRights(_entityId: any, _roleId: any): Promise<any> {
    return Promise.resolve({ data: [] });
  }
}
export default new MastersServiceStub();
